module.exports = __webpack_public_path__ + "static/img/erys.7b7fc93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/erys.jpg
// module id = j492
// module chunks = 1